// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"505a8bde","453":"0d7141e8","667":"d7d015f3"}[chunkId] + ".chunk.js";
};